const styles = {
  label: {
    fontSize: '14px',
    lineHeight: '18px',
    fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
    '& .MuiFormLabel-asterisk': {
      color: 'red',
      fontSize: '14px',
      marginLeft: '3px',
    },
  },
  select: {
    fill: '#130F26',
    width: '100%',
    '& em': {
      color: '#707087',
      fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
      fontStyle: 'normal',
    },
    '& svg': {
      right: 6,
      top: 6,
    },
  },
  description: {
    color: '#707087',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '18px',
    fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
    marginTop: '2px',
    fontStyle: 'italic',
  },

  selecValue: {
    width: '100%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    paddingRight: '10px',
  },
}
export { styles }
